import React from "react";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Existing Components (Homepage)
import Navbar from "./components/Navbar";
import Marquee from "./components/Marquee";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import EnquiryModal from './components/Enquirymodal';


// New Pages
import Chennai from "./pages/Chennai";
import Madurai from "./pages/Madurai";
import Coimbatore from "./pages/Coimbatore";

// ✅ Homepage Component (your current layout)
function Home() {
  return (
    <div className="app">
      <Navbar />

      <div className="page-body">
        <Marquee />
        <Hero />
        <About />
        <Menu />
        <Services />
        <Gallery />
        <Testimonials />
        <Contact />
        <Footer />
      </div>

      <WhatsAppButton />
      <EnquiryModal />
      
    </div>
  );
}
// ✅ Main App with Routing
function App() {
  return (
    <Router>
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<Home />} />

        {/* City Pages */}
        <Route path="/catering-services-chennai" element={<Chennai />} />
        <Route path="/catering-services-madurai" element={<Madurai />} />
        <Route path="/catering-services-coimbatore" element={<Coimbatore />} />
      </Routes>
    </Router>
  );
}

export default App;